import { render } from "./TablaServiciosColectivosSolicitadosCompleto.vue?vue&type=template&id=10f90b97&ts=true"
import script from "./TablaServiciosColectivosSolicitadosCompleto.vue?vue&type=script&lang=ts"
export * from "./TablaServiciosColectivosSolicitadosCompleto.vue?vue&type=script&lang=ts"

import "./TablaServiciosColectivosSolicitadosCompleto.vue?vue&type=style&index=0&id=10f90b97&lang=css"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__